export enum DispatchableType {
  NEW = 'new',
  DISPATCHABLE = 'dispatchable',
  NOTDISPATCHABLE = 'notDispatchable',
}
